import { ENEMY_BASE } from "../game/constants/enemies";
import { TOWER_DEFS } from "../game/constants/towers";

const towerPath = {
	blaster: "M12 20 L20 8 L32 8 L40 20 L32 32 L20 32 Z M26 20 L42 20",
	cannon: "M12 20 L20 9 L34 12 L40 20 L34 28 L20 31 Z M26 16 L42 16 L42 24 L26 24",
	sniper: "M16 10 L34 10 L40 20 L34 30 L16 30 L10 20 Z M20 20 L44 20 M31 14 L37 26",
	frost: "M24 8 L32 16 L28 20 L32 24 L24 32 L16 24 L20 20 L16 16 Z M24 11 L24 29 M15 20 L33 20",
	tesla: "M13 18 L22 8 L35 11 L40 22 L32 32 L18 31 Z M24 12 L20 21 L27 20 L23 30 L36 16 L29 17 Z",
};

const enemyPoints = {
	scout: "24,9 39,20 24,31 9,20",
	soldier: "14,12 34,12 40,20 34,28 14,28 8,20",
	tank: "11,16 18,9 30,9 37,16 37,24 30,31 18,31 11,24",
	sprinter: "12,32 24,8 40,32",
	healer: "24,8 39,19 33,36 15,36 9,19",
	reinforced: "9,17 17,8 31,8 39,17 36,31 24,38 12,31",
	fireman: "24,7 36,20 30,34 18,34 12,20",
	frostbite: "24,8 37,15 37,29 24,36 11,29 11,15",
	boss: "24,6 36,10 42,22 36,34 24,38 12,34 6,22 12,10",
};

export function TowerSpriteBadge({ type }) {
	const def = TOWER_DEFS[type] || TOWER_DEFS.blaster;

	return (
		<span className="sprite-badge" style={{ "--tone": def.color }} aria-hidden="true">
			<svg viewBox="0 0 48 40" role="img">
				<path className="sprite-badge__fill" d={towerPath[type] || towerPath.blaster} />
				<circle className="sprite-badge__core" cx="24" cy="20" r="3.6" />
			</svg>
		</span>
	);
}

export function EnemySpriteBadge({ type }) {
	const enemy = ENEMY_BASE[type] || ENEMY_BASE.scout;

	return (
		<span className="enemy-sprite-badge" style={{ "--tone": enemy.color }} aria-hidden="true">
			<svg viewBox="0 0 48 44" role="img">
				<polygon className="sprite-badge__fill" points={enemyPoints[type] || enemyPoints.scout} />
				<circle className="sprite-badge__core" cx="20" cy="18" r="2.2" />
				<circle className="sprite-badge__core" cx="28" cy="18" r="2.2" />
			</svg>
		</span>
	);
}
